import { create } from "zustand";

export type ConnectionStatus = "connecting" | "connected" | "disconnected" | "error";

/**
 * Stav WS spojení prohlížeče — jediná metrika v aplikaci měřená na KLIENTU, ne na serveru.
 *
 * Pole `pgMon` odsud zmizelo spolu s `ConnectionStatus.tsx` a `usePgMon.ts`: `startPgMon()`
 * byl roky zakomentovaný, takže hodnota byla vždycky `null` a nikdo ji nevykresloval.
 * Statistiky Postgresu teď vozí systémový monitor (`app.pg`), a to jen když se někdo dívá.
 */
interface SystemStore {
  wsStatus: ConnectionStatus;
  setWsStatus: (s: ConnectionStatus) => void;
}

export const useSystemStore = create<SystemStore>((set) => ({
  wsStatus: "connecting",
  setWsStatus: (s) => set({ wsStatus: s }),
}));
